import React, { Component } from 'react';
import './AirList.css';
import { List } from 'antd';
import { inject, observer } from 'mobx-react';
import AirPagination from '../AirPagination';

@inject('translationsStore')
@observer
export default class AirList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: this.props.currentPage || 1
    };
  }

  componentDidMount() {
    if (this.props.currentPage && this.props.currentPage!==this.state.currentPage) {
      this.setState({ currentPage: this.props.currentPage });
    }
  }

  componentDidUpdate() {
    if (this.props.currentPage && this.props.currentPage!==this.state.currentPage) {
      this.setState({ currentPage: this.props.currentPage });
    }
  }

  next = () => {
    const { currentPage } = this.state;
    const { dataSource, pageSize } = this.props;
    let { total } = this.props;
    total = total !== undefined ? total : dataSource.length;
    const lastPage = Math.ceil(total / pageSize);
    if (currentPage < lastPage) {
      this.setState({ currentPage: this.state.currentPage + 1 },() => {
        typeof this.props.onPageChange === 'function' && this.props.onPageChange(this.state.currentPage);
      });
    }
  };

  prev = () => {
    const { currentPage } = this.state;
    if (currentPage > 1) {
      this.setState({ currentPage: this.state.currentPage - 1 },() => {
        typeof this.props.onPageChange === 'function' && this.props.onPageChange(this.state.currentPage);
      });
    }
  };

  render() {
    const { dataSource, pageSize, itemName } = this.props;
    const { currentPage } = this.state;
    let { total } = this.props;
    total = total !== undefined ? total : dataSource.length;
    return (
      <div className={`AirList ${this.props.paginationPosition || 'top'} ${this.props.className || ''}`}>
        <AirPagination pageSize={pageSize} total={total} currentPage={currentPage} next={this.next} prev={this.prev} itemName={itemName} />
        <List
          itemLayout="vertical"
          size="large"
          pagination={{
            pageSize: pageSize,
            current: currentPage,
            hideOnSinglePage: true
          }}
          dataSource={dataSource}
          renderItem={(item, index) => <List.Item key={item[this.props.rowKey || 'id']}>{this.props.renderItem(item, index + (currentPage - 1) * pageSize)}</List.Item>}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/AirList/AirList.js